// extracted by mini-css-extract-plugin
export default {"tableFooter":"styles_tableFooter__AusTP"};